import { EntityCard } from './EntityCard';

interface BrandCardProps {
  id: number;
  slug: string;
  name: string;
  description?: string | null;
  logoUrl?: string | null;
  storesCount?: number;
  isActive?: boolean;
  onClick?: (slug: string) => void;
}

/**
 * 브랜드 카드 컴포넌트
 * 보라색 테마의 EntityCard 래퍼
 */
export function BrandCard(props: BrandCardProps) {
  return <EntityCard {...props} theme="brand" />;
}
